import { animateNumber } from "../../../js/utils/helper/helper";

class ProgressBar {
  /**
   * @param {HTMLElement} element - The progress bar element
   * @param {string} petitionId - The id of the petition
   */
  constructor(element, petitionId) {
    this.element = element;
    this.petitionId = petitionId;
    this.config = {
      selectors: {
        countRelative: ".js-ProgressBar-countRelative",
        countAbsolute: ".js-ProgressBar-countAbsolute",
        progress: ".js-ProgressBar-progress",
      },
      parameters: {
        speed: 1000,
      },
      states: {
        isVisible: false /** Boolean indicating if ProgressBar is visible */,
        isAnimated: false /** Boolean indicating if animation has started */,
      },
    };
    this.countRelativeElement = element.querySelector(
      this.config.selectors.countRelative
    );
    this.countAbsoluteElement = element.querySelector(
      this.config.selectors.countAbsolute
    );
    this.progressElement = element.querySelector(
      this.config.selectors.progress
    );

    this._init();
  }

  /**
   * Runs initial function to get values
   * and if valid, save them and run animations
   */
  async _init() {
    const values = await this._getValues();
    if (values) {
      this._saveValues(values);
      this._runAnimation();
    }
  }

  /**
   * Saves the values for further use in animation
   *
   * @param {object} values - The petition count values
   */
  _saveValues(values) {
    this.values = values;
  }

  /**
   * Retrieves count values for petition via API
   *
   * @returns {Promise<object>} The petition count values
   */
  async _getValues() {
    const url = `https://counter.greenpeace.de/api/v1/petition/${this.petitionId}`;

    const response = await fetch(url, { method: "GET" });
    const results = await response.json();

    if (results && results.target && results.count)
      results.countRelative = (results.count * 100) / results.target;

    return results;
  }

  /**
   * Triggers the progress bar animation
   */
  _runAnimation() {
    if (this.config.states.isVisible && this.values) {
      this.config.states.isAnimated = true;

      /** countRelativeElement doesn't exist in the short variant of the progress bar */
      if (this.countRelativeElement) {
        animateNumber(
          this.countRelativeElement,
          this.values.countRelative,
          this.config.parameters.speed,
          "innerHTML"
        );
      }
      animateNumber(
        this.countAbsoluteElement,
        this.values.count,
        this.config.parameters.speed,
        "innerHTML"
      );
      animateNumber(
        this.progressElement,
        this.values.countRelative,
        this.config.parameters.speed,
        "value"
      );
    }
  }

  /**
   * Sets the visibility of ProgressBar
   * If set to visible, runs the animation
   *
   * @param {boolean} isVisible
   */
  setVisible(isVisible) {
    this.config.states.isVisible = isVisible;
    if (this.config.states.isVisible && !this.config.states.isAnimated) {
      this._runAnimation();
    }
  }
}

export default ProgressBar;
